module.exports = __webpack_public_path__ + "static/portfolio-5-1e22ee0eafb3c2aa5df41b079df2af06.jpg";